import React from "react"
import "../../styles/Livescoring/ToPar.css"

const ToPar = ({ toPar, special, isTotal }) => {
    let stateClass = "toPar " + (isTotal ? "isTotal " : "isNotTotal ")
    let num = toPar

    if (special == null) {
        if (toPar > 0) {
            stateClass += "over"
            num = "+" + toPar
        } else if (toPar < 0) {
            stateClass += "under"
        } else if (toPar === 0) {
            stateClass += "par"
            num = "P"
        } else {
            stateClass += "empty"
            num = "-"
        }
    } else {
        stateClass += "special"
        num = special
    }

    return <div className={stateClass}>{ num }</div>
}

export default ToPar
